<div class="page-layout blank fullwidth p-12" fusePerfectScrollbar>
   
    <!-- <mat-progress-bar class="mt-8" *ngIf="loading" mode="indeterminate"></mat-progress-bar> -->
    <div class="payment mt-8 p-8">   
        <div class="back-heading">
            <i (click)="goBack()" class="go-back" style="color: black;font-weight: bold; cursor: pointer;margin-right: 9px;">arrow_back</i>          
            <h2 class="payment-title" *ngIf="!redeemPayment" style="margin: 0;">Select Payment</h2>
            <h2 class="payment-title" *ngIf="redeemPayment" style="margin: 0;">Wallet Payment</h2>
         </div>
        <div class="payment-left">
            <div *ngIf=" variant1" class="vehicle-details-sec">
                <div class="make-sec">
                    <img 
                    [src]="'https://cube.getpitstop.com/assets/img/' + make1.toLowerCase().replace(' ', '') + '.png'" 
                    alt="Make Image"
                    class="img-fluid make-image"
                  >
                </div>
                <div class="model-sec">
                   <p> {{model1}},{{fuelType}}</p>
                <!-- </div>
                <div class="year-sec"> -->
                <!-- </div>
                <div class="variant-sec"> -->
                    <p></p>
                <!-- </div> 
                <div class="variant-sec"> -->
                    <p>  {{variant1}},[{{year1}}]</p>
                <!-- </div> 
                <div class="variant-sec" *ngIf="registrationNumber"> -->
                    <p>{{registrationNumber}}</p>
                </div> 
            </div>
            <div class="location-sec">
                <div class="payment-card"> 
                    <div class="location-icon"><mat-icon> location_on</mat-icon></div>
                    <div class="location-content">
                        <div class="location-title">Shipping Address</div>
                        <div class="location-details">
                            {{shippingAddress}}
                        </div>
                    </div>
                </div>
            </div> 
            <!-- {{walletData|json}} -->
            <!-- autoverse wallet -->
            <div class="wallet-sec" *ngIf="walletData?.wallet?.isWallet==true && walletData?.wallet?.walletAmount>0 && !redeemPayment">
                <div class="wallet-card-pay">
                    <div class="wallet-icon1" style="margin-left: 10px; color: #144579;">
                        <mat-icon>account_balance_wallet</mat-icon>
                    </div>
                    <div class="wallet-content">
                        <div class="wallet-title">Autoverse  Wallet</div>
                        <!-- <div class="wallet-balance">Available Balance: {{(walletData.wallet.walletAmount-walletAmountToUse) | number:'1.2-2'}}</div> -->
                        <div class="wallet-balance">
                            Available Balance: {{(walletChecked ? (walletData.wallet.walletAmount - walletAmountToUse) : walletData.wallet.walletAmount) | number:'1.2-2'}}
                            
                        </div>
                    </div>
                    <div class="wallet-checkbox-last">
                        <input type="checkbox" [(checked)]="walletChecked" (change)="toggleWalletCheckbox()">
                    </div>
                </div>
            </div>
<div class="wallet-sec" *ngIf="redeemPayment  && walletData?.wallet?.walletAmount>0">
                <div class="wallet-card-pay">
                    <div class="wallet-icon1" style="margin-left: 10px; color: #144579;">
                        <mat-icon>account_balance_wallet</mat-icon>
                    </div>
                    <div class="wallet-content">
                        <div class="wallet-title">Autoverse  Wallet</div>
                        <!-- <div class="wallet-balance">Available Balance: {{(walletData.wallet.walletAmount-walletAmountToUse) | number:'1.2-2'}}</div> -->
                        <div class="wallet-balance">
                            Available Balance: {{(walletChecked ? (walletData.wallet.walletAmount - walletAmountToUse) : walletData.wallet.walletAmount) | number:'1.2-2'}}
                            
                        </div>
                    </div>
                    <div class="wallet-checkbox-last">
                        <input type="checkbox" [(checked)]="walletChecked" (change)="toggleWalletCheckbox()">
                    </div>
                </div>
           <p *ngIf="cartGrandTotal==0" class="wallet-covers">Your wallet covers the full order amount. No extra payment needed.</p>
            </div>


            <div class="payment-sec" *ngIf="cartGrandTotal>0">
                <div class="payment-card"> 
                    <div class="payment-title" style="padding: 12px 0px;">Mode of Payment</div>
                    <mat-radio-group aria-label="Select an option">
                        <mat-radio-button value="1" (click)="getPaymentMode(1)" *ngIf="!redeemPayment">
                            <div class="cod-btn"> 
                                <mat-icon>account_balance_wallet</mat-icon>
                                <span>Cash On Delivery</span>
                            </div>
                        </mat-radio-button>
                        <mat-radio-button value="2" (click)="getPaymentMode(2)" *ngIf="roleType !== 'autoverse_employee' && !redeemPayment">
                            <div class="cod-btn"> 
                                <mat-icon>payment</mat-icon>
                                <span *ngIf="!prepayUpiDiscount">Pay Online</span>
                                <span *ngIf="prepayUpiDiscount ">Pay by UPI</span>
                            </div>
                        </mat-radio-button>
                        <mat-radio-button value="2" (click)="getPaymentMode(2)" *ngIf="redeemPayment">
                            <div class="cod-btn"> 
                                <mat-icon>payment</mat-icon>
                                <span *ngIf="!prepayUpiDiscount">Pay Online</span>
                                <span *ngIf="prepayUpiDiscount ">Pay by UPI</span>
                            </div>
                        </mat-radio-button>
                         <mat-radio-button value="8" (click)="getPaymentMode(8)" *ngIf="autoverseCredit?.availableCreditAmount>= cartGrandTotal1 && !redeemPayment">
                            <div class="cod-btn"> 
                                <mat-icon>payment</mat-icon>
                               <img src="assets/images/logos/credit.png" class="creadit-image">
                            </div>
                        </mat-radio-button>
                        <span *ngIf="prepayUpiDiscount && prepayUpiDiscount!=undefined && prepayUpiDiscount!= 'undefined'" class="online-payment-sub-heading">{{prepayUpiDiscount}}</span>
                    </mat-radio-group>
                    <div class="credit-tooltip-container" 
                        (mouseenter)="showTooltip = true" 
                        (mouseleave)="showTooltip = false"
                         *ngIf="autoverseCredit?.availableCreditAmount>= cartGrandTotal1 && !(redeemPayment)">
                    <div class="show-credit" ><strong>₹</strong> Show my credit limit</div>
                    <div class="credit-tooltip-content" *ngIf="showTooltip">
                        <h3>My Credit Limit on <img src="assets/images/logos/credit.png" ></h3>
                        <div class="credit-info">
                        <div class="row">
                            <span>Allocated Credit</span>
                            <strong>₹ {{ autoverseCredit.creditLimit | number }}</strong>
                        </div>
                        <div class="row">
                            <span>Available Credit</span>
                            <strong>₹ {{ autoverseCredit?.availableCreditAmount | number }}</strong>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            <p *ngIf="walletChecked && redeemPayment" class="wallet-covers">Your wallet covers ₹{{walletAmountToUse}}. Please pay ₹{{cartGrandTotal}} to complete your order.</p>
            </div> 
        </div>
        
        <div class="payment-right">
            <div #target  class="price-details-sec" [@shakeit]="this.states['shake']" (@shakeit.done)="shakeEnd('shake', $event)">
                <div class="payment-card"> 
                    <div class="price-details-title">Price Details</div>
                    <div class="price-details">
                        <div class="price-details-left">Spares Total</div>
                        <div class="price-details-right">&#8377;{{cartSubTotal | number:'1.2-2'}}</div>
                    </div>

                    <!-- Spares Discount -->
                    <div class="price-details" *ngIf="sparesDiscount>0">
                        <div class="price-details-left">Spares Discount</div>
                        <div class="price-details-right" id="discount">- &#8377;{{sparesDiscount | number:'1.2-2'}}</div>
                    </div>
                  
                    <div *ngIf="!(redeemPayment)">
                    <div class="price-details" *ngIf="(slotName=='instantDelivery' && shippingCharges == 0 )|| (slotName=='smartSlot' && slotData?.currentSlot.shippingCharges ==0) || (slotName=='pickUp' && slotData?.wareHouseData[0].shippingCharges ==0)">
                        <div class="price-details-left">Shipping Charges 
                            <i style="cursor: pointer;" class="maticon" mat-raised-button  (click)="openBottomSheet()">
                            info_outline
                          </i></div>
                        <div class="price-details-right" >
                            <span class="free-badge">FREE</span>
                            <span style="text-decoration: line-through">₹{{shippingCharges}}</span>
                        </div>
                    </div>

                    <div class="price-details" *ngIf="((slotName=='instantDelivery' || !(slotName=='smartSlot' || slotName=='pickUp' || slotName=='instantDelivery')) && shippingCharges > 0) || (slotName=='smartSlot' && slotData?.currentSlot.shippingCharges >0) || (slotName=='pickUp' && slotData?.wareHouseData[0].shippingCharges >0)">
                        <div class="price-details-left">Shipping Charges
                            <i style="cursor: pointer;" class="maticon" mat-raised-button  (click)="openBottomSheet()">
                                info_outline
                              </i>
                        </div>
                        <div class="extra-cost">
                              <div class="card-footer">
                                    <span class="tag extra" >💸 Extra cost</span>
                                </div>
                            <span class="price-details-right" style="width: fit-content;margin-left: 6px;" >₹{{shippingCharges}}</span>
                            </div>
                    </div> 
                    
                    <div class="slot-badge" *ngIf="slotName=='smartSlot'">
                        <img src="../../../../assets/images/slot-delivery/car1.png">
                        <span>FREE Smart Slot</span>
                    </div>
                    <div class="slot-badge" *ngIf="slotName=='pickUp'">
                        <img src="../../../../assets/images/slot-delivery/location-color.png">
                        <span>Free Pickup from Store</span>
                    </div>
                     <div class="slot-badge" *ngIf="slotName=='instantDelivery'">
                        <img src="../../../../assets/images/slot-delivery/instant-pick.png">
                        <span *ngIf="shippingCharges>0 ">Instant Delivery - Chargeable</span>
                        <span *ngIf="shippingCharges==0 ">Instant Delivery - FREE</span>
                    </div>
                    
                    </div>

                    <div *ngIf="redeemPayment">
                    <div class="price-details" >
                        <div class="price-details-left">Shipping Charges </div>
                        <div class="price-details-right" >
                            <span class="free-badge">FREE</span>
                            <!-- <span style="text-decoration: line-through">₹0</span> -->
                        </div>
                    </div>
                    </div>
                    <ng-template #bottomSheetTemplate >
                        <!-- <div class="bottom-sheet-content">
                            <i class="material-icons" (click)="closeBottomSheet()" style="float: left; cursor: pointer;">cancel</i>
                          <h3 style="font-weight: bold;">Shipping Charge</h3>
                          <p style="font-size: 13px;">Autoverse provides free Shipping for orders above ₹ {{avoidShippingCharges}}</p>
                          <button mat-button class="custom-button" (click)="closeBottomSheet()">Okay, Got it</button>
                        </div> -->
                        <!-- Fullscreen Modal Overlay -->

                      </ng-template> 
                  

                    <!-- autoverse app wallet used -->
                     <div class="price-details" *ngIf="walletChecked && walletData?.wallet?.walletAmount>0">
                        <div class="price-details-left">Autoverse  Wallet Used: </div>
                        <div class="price-details-right" id="wallet">- {{ walletAmountToUse | number:'1.2-2'}}</div>
                     </div>


                    <!-- Coupon Discount -->
                    <!-- <div class="price-details" >
                        <div class="price-details-left">Coupon Discount</div>
                        <div class="price-details-right" id="coupon-discount">-100</div>
                    </div>   -->
                             
                    <!-- Shipping Charges -->
                    <div *ngIf="isShippingCharges=='true'" class="price-details" id="shipping-charges">
                        <div class="price-details-left">Shipping Charges <mat-icon (click)="shippingChargesBottomSheet()">info</mat-icon></div>
                        <div *ngIf="shippingChargesApplicable==true" class="price-details-right">&#8377;{{shippingCharges | number:'1.2-2'}}</div>
                        <div *ngIf="shippingChargesApplicable==false" class="price-details-right">
                            <span class="mrp-price">&#8377;{{shippingCharges | number:'1.2-2'}}</span>
                            <span id="free-shipping">FREE</span>
                        </div>
                    </div>  

                    <!-- <div class="price-details" id="total" *ngIf="walletChecked && walletAmountToUse && walletAmountToUse>0">
                        <div class="price-details-left">Total</div>
                        <div class="price-details-right">&#8377;{{(cartGrandTotal-walletAmountToUse) | number:'1.2-2'}}</div>
                    </div> -->

                    <div class="price-details" id="total" >
                        <div class="price-details-left">Total</div>
                        <div class="price-details-right">&#8377;{{(cartGrandTotal) | number:'1.2-2'}}</div>
                    </div>
                </div>
            </div>
               <div class="wallet-summary" *ngIf="redeemPayment">
            <h3>Wallet Payment Summary</h3>
            <p class="good-news">🎉<strong>Good news!</strong></p>
            <p *ngIf="(cartSubTotal)>walletAmountToUse ">Your wallet covers 
                <span class="wallet-amount" >₹{{walletAmountToUse}}</span>
            </p>
            <p *ngIf="(cartSubTotal)<=walletAmountToUse">
                Your wallet covers the full order amount.
            </p>
            <div class="pay-remaining" *ngIf="(cartSubTotal)>walletAmountToUse">
                You just need to pay <span class="remaining-amount">₹{{(cartSubTotal) - walletAmountToUse}}</span> to complete this order.
            </div>
            <div class="pay-remaining" *ngIf="(cartSubTotal)<=walletAmountToUse">
               No extra payment needed.
            </div>
            </div>
        </div>

        

        
    </div>
    <div class="confirm-order-sec" *ngIf="paymentMethod && initiatedPayment!=true && shippingAddressId && billingAddressId">
        <div class="grand-total">&#8377;{{cartGrandTotal | number:'1.2-2'}}</div>
        <div class="view-details">
            <a (click)="scroll(target)">View Details</a>
        </div>
        <button class="confirm-order-btn" (click)="confirmOrder(paymentMethod)">{{paymentButtonText}}</button>
    </div>
    <div class="confirm-order-sec" *ngIf=" redeemPayment && cartGrandTotal==0 && initiatedPayment!=true && shippingAddressId && billingAddressId">
        <div class="grand-total">&#8377;{{cartGrandTotal | number:'1.2-2'}}</div>
        <div class="view-details">
            <a (click)="scroll(target)">View Details</a>
        </div>
        <button class="confirm-order-btn" (click)="confirmOrder('1')">Confirm Order</button>
    </div>
</div>
<div class="overlay" *ngIf="isPopupVisible" [class.visible]="isPopupVisible" (click)="closePopup()"></div>
<div class="popup-overlay" *ngIf="isPopupVisible">
  <img src="assets/images/errormsg.png" class="popup-background" alt="Background" />
    <i (click)="closePopup()">cancel</i>
  <div class="popup-box">
    <div class="logo">
        <img src="assets/images/logos/mobile_autoverse_logo.svg" class="popup-logo" alt="Autoverse" />
        <div class="text">AUTOVERSE</div>
    </div>
    <h2>{{messageHeading}}</h2>
    <p>{{message}}</p>

    <button (click)="makePayment()" *ngIf="createOrderErr">Make Payment</button>
    <button (click)="closePopup()" *ngIf="errorMsg">Okay,Got It</button>
    <button (click)="closePopup()" *ngIf="paymentError">Please Try Again</button>


  </div>
</div>

<!-- // ========NO REGISTRATION NUMBER POPUP=========== -->
 <div class="overlay" *ngIf="showRegistrationPopup" [class.visible]="showRegistrationPopup" (click)="closePopup()"></div>
<div class="registration-popup-overlay" *ngIf="showRegistrationPopup">
  <div class="registration-popup-backdrop"></div>
    <!-- <img src="../../../../assets/images/no-registration-number-background-image.png" class="popup-background" alt="Background" /> -->
      <img [src]="registrationPopupData.image" alt="Autoverse" class="popup-background" />
  <div class="registration-popup-box">
    <div class="registration-popup-header">
        <img src="assets/images/logos/mobile_autoverse_logo.svg" alt="Autoverse Logo" class="registration-popup-logo" />
      <span class="registration-popup-title">AUTOVERSE</span>
    </div>
     <h2>{{ registrationPopupData.heading || 'Wait, no registration number?' }}</h2>
    <p>{{ registrationPopupData.subtext || 'Invoice needs it for correct returns and warranties, you know.' }}</p>
    <div class="registration-popup-actions">
     <button (click)="addRegistrationNumber()">
        {{ registrationPopupData.ctaPrimary || 'Add Car’s Registration Number' }}
        </button>

        <button class="secondary" (click)="createOrder('', '', '')">
    I’ll Do This Later
    </button>


    </div>
  </div>
</div>
<!-- ==================ANOTHER POPUP============ -->
 <div class="overlay" *ngIf="showBottomSheet" [class.visible]="showBottomSheet" (click)="closePopup()"></div>
<div class="reg-bottomsheet-overlay" *ngIf="showBottomSheet">
  <div class="reg-bottomsheet-box">
    <!-- <mat-icon click="closeRegistrationNumber()" >close</mat-icon> -->
    <div class="reg-bottomsheet-title">{{ registrationBottomSheetData.title || 'Enter your car registration number' }}</div>

        <div [formGroup]="regForm">
        <div class="form-group">
            <div class="input-group">
            <span class="small-img">
                <img src="assets/images/my-job-card-images/circle.png" class="input-icon" alt="Car KM" />
                IND
            </span>
            <input
                type="text"
                formControlName="registrationNumber"
                maxlength="13"
                placeholder="KA 04 JA 54**"
                (input)="onRegistrationInput($event)" />
            </div>
            <div class="error" *ngIf="regForm.get('registrationNumber')?.hasError('required') && regForm.get('registrationNumber')?.touched">
            Please enter car number
            </div>
            <div class="error" *ngIf="regForm.get('registrationNumber')?.hasError('invalidFormat') && regForm.get('registrationNumber')?.touched">
            Please enter a valid registration number
            </div>
        </div>
        </div>



    <ul class="info-list">
        <li>
            <mat-icon class="circle">check_circle</mat-icon>
            <span class="get">{{ registrationBottomSheetData.details || 'Invoice will have full details' }}</span>
        </li>
        <li>
            <mat-icon class="circle">check_circle</mat-icon>
            <span class="get">{{ registrationBottomSheetData.returnText || 'No issues during returns' }}</span>
        </li>
    </ul>

    <div class="registration-popup-actions">
      <button (click)="saveRegistrationNumber()">
        {{ registrationPopupData.ctaPrimary || 'Add Car’s Registration Number' }}
     </button>

     <button class="secondary" (click)="illDoLater()">I’ll Do This Later</button>
    </div>
  </div>
</div>

<!-- // ========NO REGISTRATION NUMBER POPUP END =========== -->


<div class="popup-overlays" *ngIf="freeShipping && slotName=='smartSlot'">
<div class="popup-modal">

    <!-- Header -->
    <div class="popup-header">
    <img src="../../../../assets/images/slot-delivery/light-car.png" class="popup-icon">
    
    <h2 class="popup-title" style="color: black;">Why is shipping FREE?</h2>
    <i class="popup-close" (click)="closeShipping()">close</i>
    </div>

    <!-- Title & Subtitle -->
    <p class="popup-subtitle" style="color: #6B7280;">
    You chose Smart Slot. We club orders and deliver in a predictable slot.
    </p>

    <!-- Delivery Info -->
    <div class="popup-row light-blues" style="border: 1px solid #BAE6FD;color: #0369A1;">
    <span class="popup-row-icon">⏱</span>
    <span>Arrives {{ getDeliveryLabel(slotData?.currentSlot.customerDeliveryTime) }}</span>
    </div>
    <p class="popup-subtext" style="color: #6B7280;">Order By: {{ getUpcoming(slotData?.currentSlot.orderWindowEnd) }}</p>

    <!-- Benefits List -->
    <div class="popup-benefits">
    <p><img src="../../../../assets/images/slot-delivery/doller.png"> Fewer trips, lower logistics cost</p>
    <p><img src="../../../../assets/images/slot-delivery/right.png"> Predictable delivery window</p>
    <p><img src="../../../../assets/images/slot-delivery/doller.png"> ₹{{slotData?.currentSlot.shippingCharges | number:'1.0-0'}} shipping for this order</p>
    </div>

    <p class="popup-note" style="color: #9CA3AF;">
    Change delivery at the previous step if you need Instant.
    </p>

    <!-- Buttons -->
    <div class="popup-actions">
    <button class="popup-btn primary" (click)="closeShipping()">Keep Smart Slot</button>
    <button class="popup-btn secondary" (click)="goToSlot()">Change delivery</button>
    </div>
    
</div>
</div>
<div class="popup-overlays"  *ngIf="freeShipping && slotName=='pickUp'">
<div class="popup">

<div class="header">
    <span class="header1">
    <img class="icon" src="../../../../assets/images/slot-delivery/color-location.png" style="width: 13%;">
    <h2>Why is shipping FREE?</h2>
    </span>
    <i (click)="closeShipping()">close</i>
</div>

<p class="subtext">Pick up from our store—no shipping fee.</p>

<div class="location-box">
    <div class="location">
    <img class="location-icon" src="../../../../assets/images/slot-delivery/location-color.png">
    <div class="location-details">
        <p class="address" style="margin: 0;">{{slotData?.wareHouseData[0].warehouseName}}</p>
        <div class="address">{{slotData?.wareHouseData[0].address1}} {{slotData?.wareHouseData[0].address2}} {{slotData?.wareHouseData[0].country}} {{slotData?.wareHouseData[0].zip}}</div>
        <div class="hours">Open {{slotData?.wareHouseData[0].storeTime}}</div>
    </div>
    </div>
</div>

<div class="tags">
    <div class="tag no-fee"  *ngIf="slotData?.wareHouseData[0].shippingCharges ==0">🚫 No shipping fee</div>
    <div class="tag priority">⚡ Priority counter</div>
</div>

<button class="btn" (click)="openMap()">Get Directions</button>

<div class="change-link" (click)="goToSlot()">Change delivery</div>

<!-- <p class="note">Bring your Order ID at the counter.</p> -->
</div>

</div>
<div class="overlay" (click)="closeShipping()"  [class.visible]="freeShipping" *ngIf="freeShipping" ></div>

<div class="modal" *ngIf="freeShipping && slotName=='instantDelivery' && shippingCharges>0">
  <h2>🕒 Why am I paying ₹{{shippingCharges}}?</h2>
  <p class="subtext">Instant sends a separate trip to deliver immediately.</p>
  <p class="free-offer">✨ Free instant delivery on orders above ₹{{avoidShippingCharges}}</p>

  <div class="tip-box">
    <p class="tip">💡 Tip: Choose Smart Slot & Save ₹{{shippingCharges}}</p>
    <p class="catch">⏳{{convertMinutesToTimeLabel(slotData?.currentSlot.orderConfirmTime)}} left to catch {{ getUpcoming(slotData?.currentSlot.customerDeliveryTime) }} delivery</p>
    <button class="primary" (click)="switchToSmartSlot()">Switch to Smart Slot</button>
  </div>

  <button class="secondary" (click)="closeShipping()">Continue with Instant</button>
</div>

<!-- modal -->
<div class="modal" *ngIf="freeShipping && slotName=='instantDelivery' && shippingCharges==0">
  <h2>🕒 <strong>Instant is free today</strong></h2>
  <p class="subtext" style="color: black;">
    You're not paying a delivery fee on orders above ₹{{avoidShippingCharges}}.
  </p>

  <p class="green-tip" style="text-align: left;">
    💡 Still better: Smart Slot arrives {{ getDeliveryLabel(slotData?.currentSlot.customerDeliveryTime) }} and helps cut extra trips.
  </p>

  <div class="info-box">
    <p class="green-tip">✨ Choose Smart Slot for predictable delivery</p>
    <p class="catch">⏳ {{convertMinutesToTimeLabel(slotData?.currentSlot.orderConfirmTime)}} left to catch {{ getUpcoming(slotData?.currentSlot.customerDeliveryTime) }} delivery</p>
    <button class="primary" (click)="switchToSmartSlot()">Choose Smart Slot</button>
  </div>

  <button class="secondary" (click)="closeShipping()">
    Proceed with Instant
  </button>
</div>



<script src="https://checkout.razorpay.com/v1/checkout.js"></script>
